import React from 'react';
import { Stack, Button, Typography, Divider } from '@mui/material';
import getKeyValue from '../../../utils/helpers/get-key-value';
import { isValidArray } from '../../../utils/is-array';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import LayImage from '../../common/lazy-load-image';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import {ReactComponent as VerifiedUsers} from './verified_users.svg';
import { COLOR_TO_HEX_MAPPING } from '../../../constants/app-constants';

const PartSubpartReport = ({ reportData, notLastItem, handleImageOpen }) => {
    const { title, child, } = reportData || {};

    return (
        <Stack gap={1} direction='column'>
            {title && <Button variant='text' className='w-max mb-2 p-0 font-bold' startIcon={<SubtitlesIcon />}>{title}</Button>}
            {child && child.map((item, idx, arr) => (
                <React.Fragment key={idx}>
                    <Stack gap={1} direction='row' className={`${arr?.length === idx + 1 ? '-mb-3' : ''}`} justifyContent={'space-between'}>
                        <Stack gap={1} width='85%'>
                            <Typography variant="body1" className='font-bold flex items-center'>
                                {item?.guaranteed && <VerifiedUsers className='h-4 w-4 text-success mr-2'/>}
                                <span>{`${item?.part}${item?.subPart ? ` - ${item?.subPart}` : ''}`}</span>
                            </Typography>
                            {isValidArray(item?.additionalInfo) && <Typography variant="body2" className='opacity-70 ml-0.5' >
                                {item?.additionalInfo?.map((info, indx) => (
                                    <React.Fragment key={indx}>
                                        <span>{getKeyValue(info)?.key} - {getKeyValue(info)?.value}</span>{indx + 1 < item?.additionalInfo?.length && ', '}
                                    </React.Fragment>
                                ))}
                            </Typography>}
                            {isValidArray(item?.choices) && <Typography variant="body2" className='opacity-70 ml-0.5' >
                                {item?.choices?.map((choice, indx) => (
                                    <React.Fragment key={indx}>
                                        <span className='font-bold' style={{color: COLOR_TO_HEX_MAPPING[item?.choiceStatus?.[choice]] || '#576586'}}>
                                            {choice}
                                        </span>
                                        {indx + 1 < item?.choices?.length && ', '}
                                    </React.Fragment>
                                ))}
                            </Typography>}
                        </Stack>
                        {isValidArray(item?.images) && <LayImage height={36} width={36} src={`${item?.images[0]?.url}?width=0.06`} alt={item?.images[0]?.label} onClick={handleImageOpen.bind(null, item?.images[0])} className='rounded self-end' />}
                    </Stack>
                    {isValidArray(item?.videos) && <LazyLoadComponent><ReactPlayer url={item?.videos[0]?.url} height='100%' controls={true} width='100%' /></LazyLoadComponent>}
                    {idx + 1 < child?.length && <Divider className='my-1 border-v-light-br' />}
                </React.Fragment>
            ))
            }
            {notLastItem && <Divider sx={{ margin: '12px 0' }} className='shadow border-light-border' />}
        </Stack>
    );
};

PartSubpartReport.propTypes = {
    reportData: PropTypes.object,
    notLastItem: PropTypes.bool,
    handleImageOpen: PropTypes.func
};

export default PartSubpartReport;
